import React from 'react'
import { FormCheckbox, FormCheckboxProps } from 'semantic-ui-react'
import { ReduxFieldProps, SemanticFieldProps, mapErrorProps } from './SemanticField'
import { Field, WrappedFieldProps } from 'redux-form'
import { useRegisterTab } from './Tabs/TabItem'

export type StrippedCheckboxProps = Omit<FormCheckboxProps, 'onBlur' | 'onChange' | 'onFocus' | 'type'>

export type ReduxCheckboxProps = SemanticFieldProps<StrippedCheckboxProps>
export type InnerFieldProps = ReduxFieldProps<StrippedCheckboxProps>

const Component = (props: WrappedFieldProps & StrippedCheckboxProps) => {
  const {
    input: { value, onChange, ...restInput },
    meta,
    label,
    usePropValue, // not sure what this is, bit it was passed to dom node causing warnings
    ...rest
  } = props

  return (
    <FormCheckbox
      {...restInput}
      type='checkbox'
      checked={!!value}
      onChange={(_, { checked }) => onChange(checked)}
      {...mapErrorProps(meta, label)}
      {...rest}
    />
  )
}

export const ReduxCheckbox: React.FC<ReduxCheckboxProps> = props => {
  useRegisterTab(props.name)

  return <Field component={Component} {...props} />
}

ReduxCheckbox.displayName = 'ReduxCheckbox'

export default React.memo(ReduxCheckbox)
